import { NO_FOLDER_FILTER } from "src/api";

export const handleNoFolderId = (folderId: string | undefined) =>
  folderId === NO_FOLDER_FILTER ? undefined : folderId;
